import React, {useState} from 'react';
import '../styling/containerStyles.css'
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Label from '../components/label'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ButtonComp from '../components/button'
// import paytmLogo from '../assets/images/paytmLogo.png'
import bankLogo from '../assets/images/bankLogo.png'
import fccPointsLogo from '../assets/images/fccPointsLogo.png';
import { Link } from 'react-router-dom';


interface TransactionDetailsProps{
    amount:string;
    redeemPoints: boolean;
    conversions: Array<any>;
    handleToProceed:Function;
    userType: string;
    bonusPoint?: Array<any>;
    specialBonus?: any;
}

export const TransactionDetails: React.FC<TransactionDetailsProps> = (props: TransactionDetailsProps) =>{

    const{
        handleToProceed, amount, redeemPoints, conversions, userType, bonusPoint, specialBonus
    } = props;
    
    const bonusAmt = bonusPoint && bonusPoint.map(b=>b.amount)
    const bonusType = bonusPoint && bonusPoint.map(b=>b.rec_type)

    const [value, setValue] = useState('')
    const [amt, setAmt] = useState('')
    const [bonusAmtVal, setBonusAmtVal] = useState('')
    // const user = userType === 'FCC'? 'FCC' : 'CWC';
    const user = userType;
    const redeemableAmt = parseFloat(amount)

    const wallet = String((redeemableAmt*parseFloat(conversions[0])).toFixed(2))
    const bank =   String((redeemableAmt*parseFloat(conversions[1])).toFixed(2))
    const points = String((redeemableAmt*parseFloat(conversions[2])).toFixed(2))
    const p_to_r = String((parseFloat(points) * parseFloat(conversions[3])).toFixed(2)) // points to reps conversion logic changes


    const walletBonusAmtCalc = bonusAmt && bonusAmt[0] ?
    bonusType && bonusType[0] === "conversion" ? 
    String((redeemableAmt*parseFloat(conversions[0])*parseFloat(bonusAmt && bonusAmt[0])).toFixed(2)) : String((redeemableAmt*parseFloat(conversions[0])+parseFloat(bonusAmt && bonusAmt[0])).toFixed(2))
    : String((redeemableAmt*parseFloat(conversions[0])).toFixed(2))

    const bankBonusAmtCalc = bonusAmt && bonusAmt[1] ?
    bonusType && bonusType[1] === "conversion" ? 
    String((redeemableAmt*parseFloat(conversions[1])*parseFloat(bonusAmt && bonusAmt[1])).toFixed(2)) : String((redeemableAmt*parseFloat(conversions[1])+parseFloat(bonusAmt && bonusAmt[1])).toFixed(2))
    : String((redeemableAmt*parseFloat(conversions[1])).toFixed(2))

    const pointsBonusAmtCalc = bonusAmt && bonusAmt[2] ?
    bonusType && bonusType[2] === "conversion" ? 
    String((redeemableAmt*parseFloat(conversions[2])*parseFloat(bonusAmt && bonusAmt[2])).toFixed(2)) : String((redeemableAmt*parseFloat(conversions[2])+parseFloat(bonusAmt && bonusAmt[2])).toFixed(2))
    : String((redeemableAmt*parseFloat(conversions[2])).toFixed(2))

    const p_to_rBonusAmtCalc = bonusAmt && bonusAmt[3] ?
    bonusType && bonusType[3] === "conversion" ? 
    String((parseFloat(points) * parseFloat(conversions[3]) * parseFloat(bonusAmt && bonusAmt[3])).toFixed(2)) 
    : String((parseFloat(points) * parseFloat(conversions[3]) + parseFloat(bonusAmt && bonusAmt[3])).toFixed(2))
    : String((parseFloat(points) * parseFloat(conversions[3])).toFixed(2)) // points to reps conversion logic changes


    const bonusAmtWallet =  String(Math.abs((walletBonusAmtCalc as any) - (wallet as any)).toFixed(2))
    const bonusAmtBank =  String(Math.abs((bankBonusAmtCalc as any) - (bank as any)).toFixed(2))
    const bonusAmtPoints = String(Math.abs((pointsBonusAmtCalc as any) - (points as any)).toFixed(2))
    const bonusAmtP_to_r = String(Math.abs((p_to_rBonusAmtCalc as any) - (p_to_r as any)).toFixed(2))


    const path = window.location.pathname;
    const pathParams = path.split('/')


    const handleClick = (option: any) => {
        if(option === 'GoBack'){
            handleToProceed(option)
        }
        if(value !== ''){
            handleToProceed(value, amt, "", bonusAmtVal)
        }
        
    }
    
    const handleRadioChange = (event: any) => {
        let val = event.target.value;
        setValue(val)
        
        if(val === 'paytm'){            
            setAmt(walletBonusAmtCalc)
            setBonusAmtVal(bonusAmtWallet)
        }
        else if( val === 'bankAccount'){
            setAmt(bankBonusAmtCalc)
            setBonusAmtVal(bonusAmtBank)
        }
        else if(val === 'fccPoints'){
            setAmt(pointsBonusAmtCalc)
            setBonusAmtVal(bonusAmtPoints)
        }
    };

    const handleRedirectApp = () => {
        window.location.replace(`https://hccinstantrewardsuat.azureedge.net/QRCode?yourQueryParamName=${pathParams[3]}`)
    }
    console.log("pathParams[1]", pathParams[1]);

        
        return (
            <div className='transactionDetails'>
                <div className='buttonAndLabel'>
                    <Button  className='goBack' onClick={() => {handleToProceed('GoBack')}} ><ArrowBackIosIcon /></Button>
                    <Label content='Transaction Details' />
                </div>
                <br></br>
                <div className='sideText'>Choose your payment method</div>                    
                
                {!redeemPoints &&
                <div>
                    <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> <br></br> 
                    {/* for future use */}
                        {/* <FormControlLabel className="transaction-list" value="paytm" control={<Radio className='radio-button' />} label={
                            <section className='menuItem'>
                                <img className='payLogo' src = {paytmLogo} alt='paytm' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtWallet) >0 ?
                                    <>
                                    <div className='payName'>Paytm  ({"₹ " + walletBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular  ({"₹ " + wallet}) + Bonus  ({"₹ " + bonusAmtWallet})</div>
                                    </>
                                    :
                                    <div className='payName'>Paytm  ({"₹ " + wallet})</div>
                                    }
                                    <div className='paySubName'>Use paytm wallet for Transaction</div>
                                </div>
                            </section>
                        }
                        /> <br></br>  */}
                        <FormControlLabel className="transaction-list" value="bankAccount" control={<Radio className='radio-button' />} label={
                            <section className='menuItem'>
                                <img className='payLogo' src = {bankLogo} alt='bank' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtBank) >0 ?
                                    <>
                                    <div className='payName'>Bank Account  ({"₹ " + bankBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular  ({"₹ " + bank}) + Bonus  ({"₹ " + bonusAmtBank})</div>
                                    </>
                                    :
                                    <div className='payName'>Bank Account  ({"₹ " + bank})</div>
                                    }
                                    <div className='paySubName'>Use bank details for Transaction</div>
                                </div>
                        </section>
                        } /> <br></br>
                        </RadioGroup>
                        {specialBonus ?
                            <div className='paySubName'>Get Special bonus reward scratch card only by scanning this token in HCC app. <Link to="" onClick={handleRedirectApp}>Open App</Link></div>
                            : null}
                </div>
                }
                {redeemPoints && 
                <div>
                    
                    <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> <br></br> 
                    {/* for future use */}
                        {/* <FormControlLabel className="transaction-list" value="paytm" control={<Radio className='radio-button' />} label={
                            <section className='menuItem'>
                                <img className='payLogo' src = {paytmLogo} alt='paytm' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtWallet) >0 ?
                                    <>
                                    <div className='payName'>Paytm  ({"₹ " + walletBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular  ({"₹ " + wallet}) + Bonus  ({"₹ " + bonusAmtWallet})</div>
                                    </>
                                    :
                                    <div className='payName'>Paytm  ({"₹ " + wallet})</div>
                                    }
                                    <div className='paySubName'>Use paytm wallet for Transaction</div>
                                </div>
                            </section>
                        }
                        /> <br></br>  */}
                        <FormControlLabel className="transaction-list" value="bankAccount" control={<Radio className='radio-button' />} label={
                            <section className='menuItem'>
                                <img className='payLogo' src = {bankLogo} alt='bank' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtBank) >0 ?
                                    <>
                                    <div className='payName'>Bank Account  ({"₹ " + bankBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular  ({"₹ " + bank}) + Bonus  ({"₹ " + bonusAmtBank})</div>
                                    </>
                                    :
                                    <div className='payName'>Bank Account  ({"₹ " + bank})</div>
                                    }
                                    <div className='paySubName'>Use bank details for Transaction</div>
                                </div>
                        </section>
                        } /> <br></br>
                        {/* {pathParams[1].toLowerCase() == "pc" &&
                        <> */}
                        <FormControlLabel className="transaction-list" value="fccPoints" control={<Radio className='radio-button' />} label={<section className='menuItem'>
                                <img className='payLogo' src = {fccPointsLogo} alt='FCC points' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtPoints) >0 ?
                                    <>
                                    <div className='payName'>{"HCC"} Points ({pointsBonusAmtCalc + " Points"}/ {"₹ " + p_to_rBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular ({points + " Points"}/ {"₹ " + p_to_r}) + Bonus ({bonusAmtPoints + " Points"}/ {"₹ " + bonusAmtP_to_r})</div>
                                    </>
                                    :
                                    <div className='payName'>{"HCC"} Points ({points + " Points"}/ {"₹ " + p_to_r})</div>
                                    }
                                    <div className='paySubName'>A special loyalty program for contractors by Pidilite</div>
                                </div>
                        </section>} /> <br></br>
                        {/* </> } */}
                    </RadioGroup>
                        {specialBonus ?
                            <div className='paySubName'>Get Special bonus reward scratch card only by scanning this token in HCC app. <Link to="" onClick={handleRedirectApp}>Open App</Link></div>
                            : null}
                </div>
                }
                <ButtonComp label= {'Proceed'} 
                                name={'PROCEED'} 
                                visible={true}
                                handleToUpdate={handleClick}  />
                </div>

          
                    
        )
    }


export default TransactionDetails